import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { api_url } from "../globalFunction/global_string";

export class SelectResearchUrl extends Component {
  static displayName = SelectResearchUrl.name;

  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      name: props.name,
      requiredAPI: props.requiredAPI,
      options: [],
      local_net_id: '',
      local_unit_id: '',
      current_user_type: localStorage.getItem('login_user_type'),
      selectedUrl: props.selectedUrl, // 將selectedUrl設置為狀態
      parentName: props.parentName,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let { parentName } = nextProps;
    if (parentName === 'Statistical' && nextProps.formData.statistical_unit_name !== prevState.local_net_id) {
      return {
        local_net_id: nextProps.formData.statistical_net_name,
        local_unit_id: nextProps.formData.statistical_unit_name,
      };
    }
    return null;
  }

  componentDidMount() {
    this.loadData(); // 在挂載時請求數據
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.selectedUnit !== prevProps.selectedUnit || this.props.local_unit_name !== prevProps.local_unit_name) {
      this.loadData();
    }
  }

  loadData() {
    this.setState({ options: [] });
    let apiUrl = api_url + this.state.requiredAPI;
    let { parentName } = this.props;

    const formData = new FormData();
    if (parentName === 'Excel') {
      formData.append("current_user_type", localStorage.getItem('login_user_type'));
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
    } else if (parentName === 'Statistical') {
      formData.append("current_user_type", localStorage.current_user_type);
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
      formData.append("local_unit_name", this.props.local_unit_name);
    } else if (parentName === 'url') {
      formData.append("current_user_type", localStorage.getItem('login_user_type'));
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_unit_id", this.props.selectedUnit); // 使用 props 中的 selectedUnit
      formData.append("local_unit_name", this.props.local_unit_name); // 使用 props 中的 local_unit_name
    }
    else if (parentName === 'urlN') {
      formData.append("current_user_type", localStorage.getItem('login_user_type'));
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
      formData.append("local_unit_name", localStorage.getItem('login_local_unit_name'));
    } else if (parentName === 'superS') {
      formData.append("current_user_type", localStorage.getItem('login_user_type'));
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
      formData.append("local_unit_name", this.props.local_unit_name);
    }

    //console.log("fetchAddrBeforeFetch:", this.state);
    // 發起 AJAX 請求，並將回應的資料更新至狀態中的 options
    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        // console.log("Received data:", data);
        let arr_status = [String(data.statusCode), data.row, data.detail];
        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];
        this.setState({ options: rows });
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
  handleSelectChange = (event) => {
    const { name, value } = event.target;
    const selectedIndex = event.target.selectedIndex;
    const selectedText = event.target.options[selectedIndex].text;
    const index = selectedText.toLowerCase().indexOf('-h');
    const pureText = selectedText.substring(0, index);
    this.setState({
      selectedName: pureText
    });

    // 將選擇的名稱一併傳遞給父組件
    this.props.onChange({ target: { name, value, selectedName: pureText } });
  };


  render() {
    return (
      <Input
        id={this.state.id}
        name={this.state.name}
        onChange={this.handleSelectChange}
        type='select'
        value={this.props.selectedUrl} // 使用 prop 設置選擇的值
      >
        <option key="0" value="">
          全部網站
        </option>
        {this.state.options.map(option => (
          option && option.url_addr ? (
            <option key={option.url_addr} value={option.url_addr}>
              {option.url_name}-{option.url_addr}
            </option>
          ) : null
        ))}
      </Input>
    );
  }
}